<template>
  <div class="organization-stations">
    <el-row :gutter="20">
      <el-col :xs="24" :lg="8" v-for="station in stations" :key="station.id">
        <el-card class="no-padding" style="margin-bottom: 20px;">
          <station-tile :station="station" @click.native="gotoStation(station)" />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Search from '@/components/shared/Search'
import StationsControls from './Stations/StationsControls'
import StationTile from './Stations/StationTile'

export default {
  name: 'OrganizationStations',
  components: { Search, StationsControls, StationTile },
  props: {
    organization: {
      type: Object,
      required: true
    },
    search: {
      type: String,
      required: false
    },
    stations: {
      type: Array,
      required: true
    }
  },
  data () {
    return {}
  },
  methods: {
    gotoStation (station) {
      this.$router.push({ name: 'Station', params: { sId: station.id } })
    }
  }
}
</script>

<style lang="scss" scoped>
  .organization-stations {
    margin-top: 79px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/organization/lists/Stations.vue